import FieldArrayHelper from "@app/components/FormikHelper/FieldArrayHelper";
import * as styles from "@app/components/AttributeSelector/AttributeSelector.module.scss";
import React from "react";
import classNames from "classnames";
import BadgeWarning from "@app/assets/images/badge_warning.svg";
import Panel, { PanelCells } from "@app/components/Panel/Panel";
import { DefaultCheckBox } from "@app/components/Checkbox/Checkbox";

const getPsaValue = (type, content, parentFieldName, fieldValue) => {
	const fieldName = `${parentFieldName}`;
	switch (type) {
		case "text":
			return content;
		case "list":
			return content.map((el) => (
				<>
					{el}
					<br />
				</>
			));
		case "radio":
		case "check":
			return (
				<FieldArrayHelper
					name={fieldName}
					renderGrid={false}
					itemsProRow={1}
					components={content.map((value) => {
						return (
							<DefaultCheckBox
								className={styles["radio-list-entry"]}
								name={`${fieldName}`}
								id={`${fieldName}_${value}`}
								label={value}
								value={value}
								key={value}
							/>
						);
					})}
				/>
			);
		default:
			return content;
	}
};
export const InfluencePanel = ({ name, entry, important, className, psaValue }) => {
	const psaCell = getPsaValue(entry.informationPsaType, entry.informationPsaContent, name, psaValue);

	const panelClass = classNames(className, {
		[styles["with-icon"]]: important,
	});

	return (
		<div className={styles["influence-panel-container"]}>
			{important && <img className={styles["important"]} src={BadgeWarning} alt="important" />}
			<Panel
				className={panelClass}
				hasBg
				header={{
					label: entry.label,
					children: (
						<div
							dangerouslySetInnerHTML={{
								__html: entry.informationContent,
							}}
						/>
					),
				}}
			>
				{entry.hint && <p>{entry.hint}</p>}
				<PanelCells
					cells={[
						{
							label: "Vorsorge",
							value: getPsaValue("text", entry.informationPrevention, name),
						},
						{
							label: "Unterweisung",
							value: getPsaValue("text", entry.informationInstruction, name),
						},
					]}
				/>
				<PanelCells
					className={styles["panel-cells"]}
					cells={[
						{
							label: "PSA",
							value: psaCell,
						},
					]}
				/>
			</Panel>
		</div>
	);
};
